export { default as ContentLayout } from './content'
